<script lang="ts">
    import {UIElement} from '../../ui-elements/element';
    import SelectedUIElementList from "./components/SelectedUIElementList.svelte";
    import PageSettings from "./components/PageSettings.svelte";
    import {OriginCoords} from '../../types';

    enum UiTabs {
        UI_ELEMENTS = 'UI_ELEMENTS',
        PAGE_SETTINGS = 'PAGE_SETTINGS',
    }

    export let selectedUiElements: UIElement[];
    export let origin: OriginCoords;

    export let showWidgetBarTop = false;
    export let onShowWidgetBarTopChange;

    // TODO: UIElementPages umbauen und verschönern
    let selectedTab = UiTabs.UI_ELEMENTS;
</script>
<div id="right-side-bar" class="border border-b-slate-200 tabs">
    <a class="tab {selectedTab === UiTabs.UI_ELEMENTS ? 'tab-lifted': ''}"
       on:click={() => selectedTab=UiTabs.UI_ELEMENTS}>UI
        Elements</a>
    <a class="tab {selectedTab === UiTabs.PAGE_SETTINGS ? 'tab-lifted': ''}"
       on:click={() => selectedTab=UiTabs.PAGE_SETTINGS}>Page settings</a>
    {#if (selectedTab === UiTabs.UI_ELEMENTS)}
        <SelectedUIElementList selectedUiElements="{selectedUiElements}" origin="{origin}"></SelectedUIElementList>
    {:else }
        <PageSettings showWidgetBarTop="{showWidgetBarTop}"
                      onShowWidgetBarTopChange="{onShowWidgetBarTopChange}"></PageSettings>
    {/if}
</div>
<style>
    #right-side-bar {
    }

</style>
